declare namespace $ {

	type $shm_hitalama_map_fontsize__font_size_shm_hitalama_map_widget_float_method_1 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_method['font_size'] >
		,
		ReturnType< $shm_hitalama_map_fontsize['font_size'] >
	>
	type $mol_view__sub_shm_hitalama_map_widget_float_method_2 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_method['method_title_sub'] >
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_select__value_shm_hitalama_map_widget_float_method_3 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_method['decorator'] >
		,
		ReturnType< $mol_select['value'] >
	>
	type $mol_select__dictionary_shm_hitalama_map_widget_float_method_4 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_method['decorator_options'] >
		,
		ReturnType< $mol_select['dictionary'] >
	>
	type $shm_hitalama_textarea__hint_shm_hitalama_map_widget_float_method_5 = $mol_type_enforce<
		string
		,
		ReturnType< $shm_hitalama_textarea['hint'] >
	>
	type $shm_hitalama_textarea__sidebar_showed_shm_hitalama_map_widget_float_method_6 = $mol_type_enforce<
		boolean
		,
		ReturnType< $shm_hitalama_textarea['sidebar_showed'] >
	>
	type $shm_hitalama_textarea__value_shm_hitalama_map_widget_float_method_7 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_method['code'] >
		,
		ReturnType< $shm_hitalama_textarea['value'] >
	>
	type $shm_hitalama_textarea__spellcheck_shm_hitalama_map_widget_float_method_8 = $mol_type_enforce<
		boolean
		,
		ReturnType< $shm_hitalama_textarea['spellcheck'] >
	>
	type $shm_hitalama_textarea__style_shm_hitalama_map_widget_float_method_9 = $mol_type_enforce<
		({ 
			'fontSize': ReturnType< $shm_hitalama_map_widget_float_method['font_size_px'] >,
		}) 
		,
		ReturnType< $shm_hitalama_textarea['style'] >
	>
	type $mol_text__text_shm_hitalama_map_widget_float_method_10 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_method['title'] >
		,
		ReturnType< $mol_text['text'] >
	>
	type $mol_text__style_shm_hitalama_map_widget_float_method_11 = $mol_type_enforce<
		({ 
			'fontSize': string,
		}) 
		,
		ReturnType< $mol_text['style'] >
	>
	type $mol_button_minor__sub_shm_hitalama_map_widget_float_method_12 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_button_minor['sub'] >
	>
	type $mol_button_minor__click_shm_hitalama_map_widget_float_method_13 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_method['title_edit'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_string__value_shm_hitalama_map_widget_float_method_14 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_method['title_draft'] >
		,
		ReturnType< $mol_string['value'] >
	>
	type $mol_string__submit_shm_hitalama_map_widget_float_method_15 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_method['title_apply'] >
		,
		ReturnType< $mol_string['submit'] >
	>
	type $mol_string__style_shm_hitalama_map_widget_float_method_16 = $mol_type_enforce<
		({ 
			'fontSize': string,
		}) 
		,
		ReturnType< $mol_string['style'] >
	>
	type $mol_button_minor__sub_shm_hitalama_map_widget_float_method_17 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_button_minor['sub'] >
	>
	type $mol_button_minor__click_shm_hitalama_map_widget_float_method_18 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_method['title_apply'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_button_minor__sub_shm_hitalama_map_widget_float_method_19 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_button_minor['sub'] >
	>
	type $mol_button_minor__click_shm_hitalama_map_widget_float_method_20 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_method['title_cancel'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	export class $shm_hitalama_map_widget_float_method extends $shm_hitalama_map_widget_float {
		font_size( next?: number ): number
		Font_size_tool( ): $shm_hitalama_map_fontsize
		Method_title( ): $mol_view
		decorator( next?: string ): string
		decorator_options( ): ({ 
			'mem': string,
			'mem_key': string,
			'process_mem': string,
			'view': string,
			'view_key': string,
			'action': string,
			'process_action': string,
			'none': string,
		}) 
		Decorator( ): $mol_select
		code( next?: string ): string
		Textarea( ): $shm_hitalama_textarea
		Title_text( ): $mol_text
		Title_edit_icon( ): $mol_icon_pencil
		title_edit( next?: any ): any
		Title_edit( ): $mol_button_minor
		title_draft( next?: string ): string
		title_apply( next?: any ): any
		Title_input( ): $mol_string
		Title_apply_icon( ): $mol_icon_check
		Title_apply( ): $mol_button_minor
		Title_cancel_icon( ): $mol_icon_close
		title_cancel( next?: any ): any
		Title_cancel( ): $mol_button_minor
		head_showed( ): boolean
		tools_custom( ): readonly(any)[]
		head( ): readonly(any)[]
		controls( ): readonly(any)[]
		method_title_sub( ): readonly(any)[]
		method_title_edit_sub( ): readonly(any)[]
	}
	
}

//# sourceMappingURL=method.view.tree.d.ts.map